import React from 'react';
import { func, number, shape, string } from 'prop-types';

import classnames from 'classnames';
import { Image } from 'nordic/image';
import { Thumbnail } from '@andes/thumbnail';

import StyledLabelWrapper from '../../../../../components/styled-label/styled-label';
import { namespace, SLIDES_LIMIT } from '../constants';
/**
 * @typedef {Object} SeeMoreProps
 * @property {(e: React.MouseEvent) => void} openModal
 * @property {Object} slide
 * @property {Object} slide.picture
 * @property {string} slide.picture.normal
 * @property {Object} slide.picture.tags
 * @property {string} slide.picture.tags.alt
 * @property {Object} slide.label
 * @property {string} slide.label.text
 * @property {string} slide.label.color
 * @property {string} slide.label.font_family
 * @property {string} slide.label.font_size
 * @property {number} index
 */

/**
 * Componente que renderiza un botón "Ver más" dentro de un carrusel especializado.
 *
 * @param {SeeMoreProps} props - Las propiedades del componente.
 * @returns {React.ReactNode} Un nodo React que contiene el botón "Ver más".
 */
export const SeeMoreButtonContent = ({ slide, openModal, index }) => {
  const buttonAriaLabel = slide?.picture?.tags?.alt || slide.label.text;

  return (
    <button
      type="button"
      onClick={openModal}
      className={`${namespace}-specialized-see-more`}
      aria-label={buttonAriaLabel}
    >
      <Thumbnail size="80">
        <Image
          alt=""
          lazyload={index < SLIDES_LIMIT ? 'off' : 'on'}
          preload={index < SLIDES_LIMIT}
          src={slide.picture.normal}
        />
      </Thumbnail>
      <StyledLabelWrapper
        className={classnames(`${namespace}-specialized-title-short`)}
        color={slide.label.color}
        font_weight={slide.label.font_family}
        size={slide.label.font_size}
        text={slide.label.text}
        as="span"
      />
    </button>
  );
};

SeeMoreButtonContent.propTypes = {
  index: number,
  openModal: func,
  slide: shape({
    picture: shape({
      normal: string,
      tags: shape({
        alt: string,
      }),
    }),
    label: shape({
      text: string,
      color: string,
      font_family: string,
      font_size: string,
    }),
  }).isRequired,
};
